import { Field, Layout } from "@introist/react-foundation/v2";
import { TextInput } from "../../../components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";

type PushApiConfig = {
  apiKey: string;
};

export const PushApiConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const credentials = (values?.credentials as PushApiConfig) ?? {
    apiKey: ""
  };

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="Api key">
        <TextInput
          placeholder="Api key"
          value={credentials.apiKey}
          onChange={apiKey =>
            onChange({
              credentials: { ...credentials, apiKey }
            })
          }
        />
      </Field>
    </Layout.Group>
  );
};
